export enum ApiErrorsSources {
    EnergyCalculator = 'ENERGY_CALCULATOR',
    BuildingProjectFiles = 'BULDING_PROJECT_FILES',
    Salesforce = 'SALESFORCE',
    SalesforceLeads = 'SALESFORCE_LEADS',
    QuoteAssist = 'QUOTE_ASSIST',
    QuotationApi = 'QUOTATION_API',
    PartnerShop = 'PARTNER_SHOP',
    ProductsManagementAPI = 'PIM_API',
    EverestUserManagement = 'EVEREST_USER_MANAGEMENT',
    IOT = 'IOT',
    DataLakeAPI = 'DATA-LAKE-API',
    PhraseAPI = 'PHRASE-API',
    SubsidyAPI = 'SUBSIDY_API'
}
